
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { name: t('nav.home'), path: '/' },
    { name: t('nav.about'), path: '/about' },
    { name: t('nav.services'), path: '/services' },
    { name: t('nav.products'), path: '/products' },
    { name: t('nav.projects'), path: '/projects' },
    { name: t('nav.contact'), path: '/contact' }
  ];

  const services = [
    'طراحی گلخانه‌های هوشمند',
    'ساخت گلخانه‌های شیشه‌ای',
    'تجهیز گلخانه‌ها',
    'مشاوره فنی',
    'نگهداری و تعمیرات'
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-100 via-slate-100 to-zinc-100 text-gray-800">
      <div className="px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-16 h-16 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/446882068b23debf400f3bc55bfe3906/15a60f8ad8230155d9447ef33246db53.png" 
                  alt="Aria Green Greenhouse Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-right">
                <h3 className="text-2xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent" style={{ fontFamily: 'Pacifico, serif' }}>
                  {t('company.name')}
                </h3>
                <p className="text-sm text-gray-600">{t('company.tagline')}</p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {t('company.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-12 h-12 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-full flex items-center justify-center hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-full flex items-center justify-center hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-full flex items-center justify-center hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer">
                <i className="ri-telegram-fill text-white"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-full flex items-center justify-center hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer">
                <i className="ri-whatsapp-fill text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-700 hover:text-emerald-600 transition-all duration-300 cursor-pointer py-1 px-2 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">{t('footer.services')}</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index} className="text-gray-700 py-1">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">{t('footer.contactInfo')}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 p-2 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300">
                <div className="w-8 h-8 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-phone-fill text-emerald-600 text-sm"></i>
                </div>
                <div className="text-gray-700">
                  <div>۰۹۱۲۹۰۹۵۳۰۲</div>
                  <div>۰۲۱۸۸۴۴۱۳۸۶</div>
                </div>
              </div>
              <div className="flex items-center space-x-3 p-2 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300">
                <div className="w-8 h-8 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-mail-fill text-emerald-600 text-sm"></i>
                </div>
                <span className="text-gray-700">{t('company.email')}</span>
              </div>
              <div className="flex items-start space-x-3 p-2 rounded-2xl hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300">
                <div className="w-8 h-8 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center mt-1">
                  <i className="ri-map-pin-fill text-emerald-600 text-sm"></i>
                </div>
                <span className="text-gray-700">{t('company.address')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-600 hover:text-emerald-600 text-sm cursor-pointer px-3 py-1 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300">
              حریم خصوصی
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-emerald-600 text-sm cursor-pointer px-3 py-1 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300">
              {t('footer.terms')}
            </Link>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-emerald-600 text-sm cursor-pointer px-3 py-1 rounded-full hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 transition-all duration-300"
            >
              {t('footer.madeWith')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
